/* Criativae · Complementos de carrinho (order bump)
   Checkbox 1-clique no padrão do gift-wrapping.js: /cart/update.js com
   updates {variantId: qty} + section bundling + pubsub cartUpdate → o tema
   re-renderiza o drawer/carrinho sozinho (a oferta some porque o item entrou). */

if (!customElements.get('cva-cart-addon')) {
  customElements.define(
    'cva-cart-addon',
    class CvaCartAddon extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="checkbox"]');
        if (!this.input) return;
        this.input.addEventListener('change', theme.utils.debounce((event) => {
          this.updateCart(event.target.checked ? 1 : 0);
        }, 200));
      }

      updateCart(quantity) {
        const loader = this.querySelector('.loader');
        if (loader) loader.hidden = false;
        if (this.input) this.input.disabled = true;

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          updates: { [this.getAttribute('data-variant-id')]: quantity },
          sections: sectionsToBundle
        });

        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cva-cart-addon', cart: parsedState });
          })
          .catch((error) => {
            console.log(error);
            if (loader) loader.hidden = true;
            if (this.input) { this.input.disabled = false; this.input.checked = !this.input.checked; }
          });
      }
    }
  );
}

/* Limpeza de complementos ÓRFÃOS: o snippet marca em <script data-cva-orphans> os itens
   complementares cujo produto "pai" saiu do carrinho; aqui eles são removidos (qty 0).
   Roda no load e após cada cartUpdate (com atraso p/ o tema terminar de re-renderizar).
   O embrulho órfão cai em cascata pela regra "só embrulho no carrinho" do gift-wrapping.js. */
(function () {
  var busy = false;
  function clean() {
    if (busy || !window.theme || !theme.routes) return;
    var el = document.querySelector('[data-cva-orphans]');
    if (!el) return;
    var ids;
    try { ids = JSON.parse(el.textContent); } catch (e) { return; }
    if (!ids || !ids.length) return;
    busy = true;
    var updates = {};
    ids.forEach(function (id) { updates[id] = 0; });
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
    fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body: JSON.stringify({ updates: updates, sections: sectionsToBundle }) } })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        busy = false;
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cva-orphan-clean', cart: state });
      })
      .catch(function () { busy = false; });
  }
  function subscribe() {
    if (window.__cvaOrphanSub) return true;
    if (!window.theme || !theme.pubsub) return false;
    window.__cvaOrphanSub = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'cva-orphan-clean') return;
      setTimeout(clean, 400);
    });
    setTimeout(clean, 300);
    return true;
  }
  if (!subscribe()) {
    document.addEventListener('DOMContentLoaded', subscribe);
    window.addEventListener('load', subscribe);
  }
})();

/* Criativae v11: força o fetch das recomendações NATIVAS do drawer — SÓ com o
   drawer ABERTO. O <product-recommendations> do tema busca a data-url via
   Motion.inView (margem só vertical; drawer fechado fica à DIREITA → não dispara
   na 1ª abertura). Na v10 o kick rodava no load com o drawer fechado: o fetch
   funcionava, mas o carrossel (flickity) inicializava com largura 0 e ficava
   desalinhado. Agora: dispara quando o drawer abre (atributo `open`) e após cada
   re-render do carrinho. init() é idempotente; resposta vazia mantém o fallback. */
(function () {
  function kickRecs() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) return;
    drawer.querySelectorAll('product-recommendations[data-url]').forEach(function (el) {
      if (el.__cvaKicked) return;
      el.__cvaKicked = true;
      if (typeof el.init === 'function') { try { el.init(); } catch (e) { /* silencioso */ } }
    });
  }
  function setup() {
    if (window.__cvaRecsSub) return true;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.theme || !theme.pubsub) return false;
    window.__cvaRecsSub = true;
    new MutationObserver(function () { setTimeout(kickRecs, 350); })
      .observe(drawer, { attributes: true, attributeFilter: ['open'] });
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(kickRecs, 500);
    });
    kickRecs();
    return true;
  }
  if (!setup()) {
    document.addEventListener('DOMContentLoaded', setup);
    window.addEventListener('load', setup);
  }
})();
